<template>
    <Modal ref="modalRef" :id="modalName" modal-dialog-class="modal-dialog-centered" modal-body-class="text-center" modal-content-class="p-4" :show-footer="true" :show-header="false">
        <h2 class="text-left">{{ $t('Monitor prices of your favourite products in your Watchlist!') }}</h2>
        <p class="text-left small">{{ $t('Create an account and never miss an opportunity to invest smartly') }}</p>

        <template #footer>
            <div class="modal-footer flex-sm-column-reverse justify-content-center border-0">
                <NuxtLink
                    :to="computedRedirectLink"
                    type="submit"
                    class="btn btn-primary"
                    @click="useModal().closeModal(modalName)"
                >
                    {{ $t('Create an account') }}
                </NuxtLink>
            </div>
        </template>
    </Modal>
</template>

<script setup>
const Modal = defineAsyncComponent(() => import("~/components/Modals/Modal.vue"));
import { useLocalePath, useRoute } from '#imports';

const localePath = useLocalePath();
const route = useRoute();

const modalName = computed(() => 'WatchlistCreateAccountModal');

const computedRedirectLink = computed(() => {
    const registerPath = localePath({ name: 'register' }) + '/';
    const indexPath = localePath({ name: 'index' }) + '/';

    if (route.fullPath && route.fullPath !== indexPath) {
        return registerPath + '?redirect=' + route.fullPath;
    }

    return registerPath;
});

</script>
